// src/screens/sales/executor/components/list/List.tsx

import React from 'react'
import { ExecutorInterface } from '../../../../../common/types/interfaces'
import { ListItem } from '../item/Item'
import classes from './List.module.sass'

type Props = {
  startEdit: (el: ExecutorInterface) => void
  startDuplicate: (el: ExecutorInterface) => void
  showDetails: (el: ExecutorInterface) => void
  list: ExecutorInterface[]
  loading?: boolean
  onAttachUser: (executorId: number) => void
  onToggleActive: (executorId: number, isActive: boolean) => void
  onTogglePublish: (executorId: number, publish: boolean) => void
  onTogglePublishMotivation: (executorId: number, publishMotivation: boolean) => void
}

export const List = ({
  startEdit,
  startDuplicate,
  list,
  showDetails,
  loading,
  onAttachUser,
  onToggleActive,
  onTogglePublish,
  onTogglePublishMotivation,
}: Props) => {
  return (
    <div className={classes.container}>
      {!list?.length && !loading ? (
        <div className={classes.Message}>Нет исполнителей</div>
      ) : (
        list.map((el) => (
          <ListItem
            key={el.id}
            el={el}
            startEdit={startEdit}
            startDuplicate={startDuplicate}
            showDetails={showDetails}
            onAttachUser={onAttachUser}
            onToggleActive={onToggleActive}
            onTogglePublish={onTogglePublish}
            onTogglePublishMotivation={onTogglePublishMotivation}
          />
        ))
      )}
    </div>
  )
}
